/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_All_SourcesInputs */

const en_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Sources`)
};

const de_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Quellen`)
};

const fr_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les sources`)
};

const es_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las fuentes`)
};

const it_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le fonti`)
};

const nl_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle bronnen`)
};

const pl_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie źródła`)
};

const fi_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki lähteet`)
};

const da_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle kilder`)
};

const sv_jobs_all_sources = /** @type {(inputs: Jobs_All_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla källor`)
};

/**
* | output |
* | --- |
* | "All Sources" |
*
* @param {Jobs_All_SourcesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_all_sources = /** @type {((inputs?: Jobs_All_SourcesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_All_SourcesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_all_sources(inputs)
	if (locale === "fr") return fr_jobs_all_sources(inputs)
	if (locale === "es") return es_jobs_all_sources(inputs)
	if (locale === "it") return it_jobs_all_sources(inputs)
	if (locale === "nl") return nl_jobs_all_sources(inputs)
	if (locale === "pl") return pl_jobs_all_sources(inputs)
	if (locale === "fi") return fi_jobs_all_sources(inputs)
	if (locale === "da") return da_jobs_all_sources(inputs)
	if (locale === "sv") return sv_jobs_all_sources(inputs)
	return en_jobs_all_sources(inputs)
});